import type { ActivityRange } from '~/types/game-pass'

/**
 * True once server time has passed the earning window's close, i.e. the
 * event's claim-only phase. The upper bound is treated inclusively; the
 * range's exclude_upper flag is intentionally ignored.
 */
export function isAfterEarningWindow(
  validRange: Pick<ActivityRange, 'upper'>,
  now: number,
): boolean {
  return now > new Date(validRange.upper).getTime()
}
